/////////COMMON ACTIONS/////////
export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_MENU_MOBILE_SELECTED = 'SET_IS_MENU_MOBILE_SELECTED';

/////////DASHBOARD ACTIONS/////////

export const GET_MY_ACCOUNT_DASHBOARD_ESPOT_PENDING = 'GET_MY_ACCOUNT_DASHBOARD_ESPOT_PENDING';
export const GET_MY_ACCOUNT_DASHBOARD_ESPOT_SUCCESS = 'GET_MY_ACCOUNT_DASHBOARD_ESPOT_SUCCESS';
export const GET_MY_ACCOUNT_DASHBOARD_ESPOT_ERROR = 'GET_MY_ACCOUNT_DASHBOARD_ESPOT_ERROR';

export const GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_PENDING =
    'GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_PENDING';
export const GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_SUCCESS =
    'GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_SUCCESS';
export const GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_ERROR =
    'GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_ERROR';

export const GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_PENDING =
    'GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_PENDING';
export const GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_SUCCESS =
    'GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_SUCCESS';
export const GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_ERROR =
    'GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_ERROR';

export const GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_PENDING =
    'GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_PENDING';
export const GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_SUCCESS =
    'GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_SUCCESS';
export const GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_ERROR =
    'GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_ERROR';

export const GET_DASHBOARD_INFORMATIONS_PENDING = 'GET_DASHBOARD_INFORMATIONS_PENDING';
export const GET_DASHBOARD_INFORMATIONS_SUCCESS = 'GET_DASHBOARD_INFORMATIONS_SUCCESS';
export const GET_DASHBOARD_INFORMATIONS_ERROR = 'GET_DASHBOARD_INFORMATIONS_ERROR';

/////////MY APPOINTMENT ACTIONS/////////

//EYE EXAMS

export const GET_USER_EYE_EXAMS_PENDING = 'GET_USER_EYE_EXAMS_PENDING';
export const GET_USER_EYE_EXAMS_SUCCESS = 'GET_USER_EYE_EXAMS_SUCCESS';
export const GET_USER_EYE_EXAMS_ERROR = 'GET_USER_EYE_EXAMS_ERROR';

export const GET_DOCTOR_INFO_PENDING = 'GET_DOCTOR_INFO_PENDING';
export const GET_DOCTOR_INFO_SUCCESS = 'GET_DOCTOR_INFO_SUCCESS';
export const GET_DOCTOR_INFO_ERROR = 'GET_DOCTOR_INFO_ERROR';

export const DELETE_EYE_EXAM_PENDING = 'DELETE_EYE_EXAM_PENDING';
export const DELETE_EYE_EXAM_SUCCESS = 'DELETE_EYE_EXAM_SUCCESS';
export const DELETE_EYE_EXAM_ERROR = 'DELETE_EYE_EXAM_ERROR';

export const SYNC_MY_EYE_EXAMS_PENDING = 'SYNC_MY_EYE_EXAMS_PENDING';
export const SYNC_MY_EYE_EXAMS_SUCCESS = 'SYNC_MY_EYE_EXAMS_SUCCESS';
export const SYNC_MY_EYE_EXAMS_ERROR = 'SYNC_MY_EYE_EXAMS_ERROR';

//IN-STORE SERVICES

export const GET_ACCESS_TOKEN_PENDING = 'GET_ACCESS_TOKEN_PENDING';
export const GET_ACCESS_TOKEN_SUCCESS = 'GET_ACCESS_TOKEN_SUCCESS';
export const GET_ACCESS_TOKEN_ERROR = 'GET_ACCESS_TOKEN_ERROR';

/////////MY PURCHASES ACTIONS/////////

export const GET_ENCRYPTED_ONLINE_ORDER_ID_PENDING = 'GET_ENCRYPTED_ONLINE_ORDER_ID_PENDING';
export const GET_ENCRYPTED_ONLINE_ORDER_ID_SUCCESS = 'GET_ENCRYPTED_ONLINE_ORDER_ID_SUCCESS';
export const GET_ENCRYPTED_ONLINE_ORDER_ID_ERROR = 'GET_ENCRYPTED_ONLINE_ORDER_ID_ERROR';

export const GET_ONLINE_ORDERS_HISTORY_PENDING = 'GET_ONLINE_ORDERS_HISTORY_PENDING';
export const GET_ONLINE_ORDERS_HISTORY_SUCCESS = 'GET_ONLINE_ORDERS_HISTORY_SUCCESS';
export const GET_ONLINE_ORDERS_HISTORY_ERROR = 'GET_ONLINE_ORDERS_HISTORY_ERROR';

export const GET_GLOBAL_ONLINE_ORDER_DETAILS_PENDING = 'GET_GLOBAL_ONLINE_ORDER_DETAILS_PENDING';
export const GET_GLOBAL_ONLINE_ORDER_DETAILS_SUCCESS = 'GET_GLOBAL_ONLINE_ORDER_DETAILS_SUCCESS';
export const GET_GLOBAL_ONLINE_ORDER_DETAILS_ERROR = 'GET_GLOBAL_ONLINE_ORDER_DETAILS_ERROR';

export const GET_ORDER_ITEM_CARRIER_URL_PENDING = 'GET_ORDER_ITEM_CARRIER_URL_PENDING';
export const GET_ORDER_ITEM_CARRIER_URL_SUCCESS = 'GET_ORDER_ITEM_CARRIER_URL_SUCCESS';
export const GET_ORDER_ITEM_CARRIER_URL_ERROR = 'GET_ORDER_ITEM_CARRIER_URL_ERROR';

export const SAVE_IN_STORE_PURCHASES_SEARCH_FILTERS = 'SAVE_IN_STORE_PURCHASES_SEARCH_FILTERS';
export const GET_IN_STORE_PURCHASES_MY_PURCHASES_PENDING =
    'GET_IN_STORE_PURCHASES_MY_PURCHASES_PENDING';
export const GET_IN_STORE_PURCHASES_MY_PURCHASES_SUCCESS =
    'GET_IN_STORE_PURCHASES_MY_PURCHASES_SUCCESS';
export const GET_IN_STORE_PURCHASES_MY_PURCHASES_ERROR =
    'GET_IN_STORE_PURCHASES_MY_PURCHASES_ERROR';

export const GET_ORDER_RETAIL_HISTORY_PENDING = 'GET_ORDER_RETAIL_HISTORY_PENDING';
export const GET_ORDER_RETAIL_HISTORY_SUCCESS = 'GET_ORDER_RETAIL_HISTORY_SUCCESS';
export const GET_ORDER_RETAIL_HISTORY_ERROR = 'GET_ORDER_RETAIL_HISTORY_ERROR';

/////////MY PROFILE ACTIONS/////////

//PERSONAL DETAILS

export const GET_GEOGRAPHIC_INFORMATIONS_PENDING = 'GET_GEOGRAPHIC_INFORMATIONS_PENDING';
export const GET_GEOGRAPHIC_INFORMATIONS_SUCCESS = 'GET_GEOGRAPHIC_INFORMATIONS_SUCCESS';
export const GET_GEOGRAPHIC_INFORMATIONS_ERROR = 'GET_GEOGRAPHIC_INFORMATIONS_ERROR';

export const GET_MY_PROFILE_PERSONAL_DETAILS_PENDING = 'GET_MY_PROFILE_PERSONAL_DETAILS_PENDING';
export const GET_MY_PROFILE_PERSONAL_DETAILS_SUCCESS = 'GET_MY_PROFILE_PERSONAL_DETAILS_SUCCESS';
export const GET_MY_PROFILE_PERSONAL_DETAILS_ERROR = 'GET_MY_PROFILE_PERSONAL_DETAILS_ERROR';

export const UPDATE_MY_PROFILE_PERSONAL_DETAILS_PENDING =
    'UPDATE_MY_PROFILE_PERSONAL_DETAILS_PENDING';
export const UPDATE_MY_PROFILE_PERSONAL_DETAILS_SUCCESS =
    'UPDATE_MY_PROFILE_PERSONAL_DETAILS_SUCCESS';
export const UPDATE_MY_PROFILE_PERSONAL_DETAILS_ERROR = 'UPDATE_MY_PROFILE_PERSONAL_DETAILS_ERROR';

//SETTINGS
export const UPDATE_SETTINGS_PASSWORD_PENDING = 'UPDATE_SETTINGS_PASSWORD_PENDING';
export const UPDATE_SETTINGS_PASSWORD_SUCCESS = 'UPDATE_SETTINGS_PASSWORD_SUCCESS';
export const UPDATE_SETTINGS_PASSWORD_ERROR = 'UPDATE_SETTINGS_PASSWORD_ERROR';
export const UPDATE_SETTINGS_PASSWORD_CUSTOM_ERROR = 'UPDATE_SETTINGS_PASSWORD_CUSTOM_ERROR';

export const GET_SETTINGS_USER_SETTINGS_PENDING = 'GET_SETTINGS_USER_SETTINGS_PENDING';
export const GET_SETTINGS_USER_SETTINGS_SUCCESS = 'GET_SETTINGS_USER_SETTINGS_SUCCESS';
export const GET_SETTINGS_USER_SETTINGS_ERROR = 'GET_SETTINGS_USER_SETTINGS_ERROR';

export const UPDATE_PERSONALIZATION_SETTINGS_PENDING = 'UPDATE_PERSONALIZATION_SETTINGS_PENDING';
export const UPDATE_PERSONALIZATION_SETTINGS_SUCCESS = 'UPDATE_PERSONALIZATION_SETTINGS_SUCCESS';
export const UPDATE_PERSONALIZATION_SETTINGS_ERROR = 'UPDATE_PERSONALIZATION_SETTINGS_ERROR';

export const CREATE_SUBSCRIPTION_PENDING = 'CREATE_SUBSCRIPTION_PENDING';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_ERROR = 'CREATE_SUBSCRIPTION_ERROR';

export const DELETE_SUBSCRIPTION_PENDING = 'DELETE_SUBSCRIPTION_PENDING';
export const DELETE_SUBSCRIPTION_SUCCESS = 'DELETE_SUBSCRIPTION_SUCCESS';
export const DELETE_SUBSCRIPTION_ERROR = 'DELETE_SUBSCRIPTION_ERROR';

// MY STORES
export const GET_FAVOURITES_STORES_PENDING = 'GET_FAVOURITES_STORES_PENDING';
export const GET_FAVOURITES_STORES_SUCCESS = 'GET_FAVOURITES_STORES_SUCCESS';
export const GET_FAVOURITES_STORES_ERROR = 'GET_FAVOURITES_STORES_ERROR';

export const REMOVE_FAVOURITE_STORE_PENDING = 'REMOVE_FAVOURITE_STORE_PENDING';
export const REMOVE_FAVOURITE_STORE_SUCCESS = 'REMOVE_FAVOURITE_STORE_SUCCESS';
export const REMOVE_FAVOURITE_STORE_ERROR = 'REMOVE_FAVOURITE_STORE_ERROR';

export const SET_DEFAULT_STORE_PENDING = 'SET_DEFAULT_STORE_PENDING';
export const SET_DEFAULT_STORE_SUCCESS = 'SET_DEFAULT_STORE_SUCCESS';
export const SET_DEFAULT_STORE_ERROR = 'SET_DEFAULT_STORE_ERROR';

// PAYMENT METHODS

export const ADD_PAYMENT_METHOD_PENDING = 'ADD_PAYMENT_METHOD_PENDING';
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS';
export const ADD_PAYMENT_METHOD_ERROR = 'ADD_PAYMENT_METHOD_ERROR';

export const EDIT_PAYMENT_METHOD_PENDING = 'EDIT_PAYMENT_METHOD_PENDING';
export const EDIT_PAYMENT_METHOD_SUCCESS = 'EDIT_PAYMENT_METHOD_SUCCESS';
export const EDIT_PAYMENT_METHOD_ERROR = 'EDIT_PAYMENT_METHOD_ERROR';

export const GET_PAYMENT_METHODS_PENDING = 'GET_PAYMENT_METHODS_PENDING';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const GET_PAYMENT_METHODS_ERROR = 'GET_PAYMENT_METHODS_ERROR';

export const SET_DEFAULT_PAYMENT_METHOD_PENDING = 'SET_DEFAULT_PAYMENT_METHOD_PENDING';
export const SET_DEFAULT_PAYMENT_METHOD_SUCCESS = 'SET_DEFAULT_PAYMENT_METHOD_SUCCESS';
export const SET_DEFAULT_PAYMENT_METHOD_ERROR = 'SET_DEFAULT_PAYMENT_METHOD_ERROR';

export const REMOVE_PAYMENT_METHOD_PENDING = 'REMOVE_PAYMENT_METHOD_PENDING';
export const REMOVE_PAYMENT_METHOD_SUCCESS = 'REMOVE_PAYMENT_METHOD_SUCCESS';
export const REMOVE_PAYMENT_METHOD_ERROR = 'REMOVE_PAYMENT_METHOD_ERROR';

// ADDRESSES
export const GET_ADDRESSES_PENDING = 'GET_ADDRESSES_PENDING';
export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS';
export const GET_ADDRESSES_ERROR = 'GET_ADDRESSES_ERROR';
export const ADD_ADDRESS_PENDING = 'ADD_ADDRESS_PENDING';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_ERROR = 'ADD_ADDRESS_ERROR';
export const EDIT_ADDRESS_PENDING = 'EDIT_ADDRESS_PENDING';
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS';
export const EDIT_ADDRESS_ERROR = 'EDIT_ADDRESS_ERROR';
export const SET_DEFAULT_ADDRESS_PENDING = 'SET_DEFAULT_ADDRESS_PENDING';
export const SET_DEFAULT_ADDRESS_SUCCESS = 'SET_DEFAULT_ADDRESS_SUCCESS';
export const SET_DEFAULT_ADDRESS_ERROR = 'SET_DEFAULT_ADDRESS_ERROR';
export const DELETE_ADDRESS_PENDING = 'DELETE_ADDRESS_PENDING';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_ERROR = 'DELETE_ADDRESS_ERROR';

// MY SAVED ITEMS

export const GET_MY_SAVED_ITEMS_PENDING = 'GET_MY_SAVED_ITEMS_PENDING';
export const GET_MY_SAVED_ITEMS_SUCCESS = 'GET_MY_SAVED_ITEMS_SUCCESS';
export const GET_MY_SAVED_ITEMS_ERROR = 'GET_MY_SAVED_ITEMS_ERROR';

//PRESCRIPTION
export const GET_PRESCRIPTION_INFO = 'GET_PRESCRIPTION_INFO';

//SUBSCRIPTION
export const GET_USER_SUBSCRIPTION_EMAIL = 'GET_USER_SUBSCRIPTION_EMAIL';
export const GET_USER_SUBSCRIPTION_PHONE = 'GET_USER_SUBSCRIPTION_PHONE';
export const GET_USER_SUBSCRIPTION_EMAIL_CHANGED = 'GET_USER_SUBSCRIPTION_EMAIL_CHANGED';
export const GET_USER_SUBSCRIPTION_PHONE_CHANGED = 'GET_USER_SUBSCRIPTION_PHONE_CHANGED';
export const GET_USER_SUBSCRIPTION_CORRECT = 'GET_USER_SUBSCRIPTION_CORRECT';

// ADD TO CART

export const ADD_TO_CART_PENDING = 'ADD_TO_CART_PENDING';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';

// MY SAVED PRESCRIPTIONS

export const GET_MY_SAVED_PRESCRIPTIONS_PENDING = 'GET_MY_SAVED_PRESCRIPTIONS_PENDING';
export const GET_MY_SAVED_PRESCRIPTIONS_SUCCESS = 'GET_MY_SAVED_PRESCRIPTIONS_SUCCESS';
export const GET_MY_SAVED_PRESCRIPTIONS_ERROR = 'GET_MY_SAVED_PRESCRIPTIONS_ERROR';

export const REMOVE_PRESCRIPTION_PENDING = 'REMOVE_PRESCRIPTION_PENDING';
export const REMOVE_PRESCRIPTION_SUCCESS = 'REMOVE_PRESCRIPTION_SUCCESS';
export const REMOVE_PRESCRIPTION_ERROR = 'REMOVE_PRESCRIPTION_ERROR';

export const GET_PD_ESPOT_PENDING = 'GET_PD_ESPOT_PENDING';
export const GET_PD_ESPOT_SUCCESS = 'GET_PD_ESPOT_SUCCESS';
export const GET_PD_ESPOT_ERROR = 'GET_PD_ESPOT_ERROR';

export const GET_HOW_TO_READ_ESPOT_PENDING = 'GET_HOW_TO_READ_ESPOT_PENDING';
export const GET_HOW_TO_READ_ESPOT_SUCCESS = 'GET_HOW_TO_READ_ESPOT_SUCCESS';
export const GET_HOW_TO_READ_ESPOT_ERROR = 'GET_HOW_TO_READ_ESPOT_ERROR';

export const GET_HOW_TO_READ_ESPOT_CL_PENDING = 'GET_HOW_TO_READ_ESPOT_CL_PENDING';
export const GET_HOW_TO_READ_ESPOT_CL_SUCCESS = 'GET_HOW_TO_READ_ESPOT_CL_SUCCESS';
export const GET_HOW_TO_READ_ESPOT_CL_ERROR = 'GET_HOW_TO_READ_ESPOT_CL_ERROR';

export const ADD_PRESCRIPTION_PENDING = 'ADD_PRESCRIPTION_PENDING';
export const ADD_PRESCRIPTION_SUCCESS = 'ADD_PRESCRIPTION_SUCCESS';
export const ADD_PRESCRIPTION_ERROR = 'ADD_PRESCRIPTION_ERROR';

export const JUST_UPDATE_ID = 'JUST_UPDATE_ID';

//CL DETAILS
export const GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_PENDING =
    'GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_PENDING';
export const GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_SUCCESS =
    'GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_SUCCESS';
export const GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_ERROR =
    'GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_ERROR';

export const GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_PENDING =
    'GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_PENDING';
export const GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_SUCCESS =
    'GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_SUCCESS';
export const GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_ERROR =
    'GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_ERROR';

export const SET_OPEN_MODAL_ADD_DOCTOR = 'SET_OPEN_MODAL_ADD_DOCTOR';

//GET DOCTOR

export const GET_DOCTOR_PENDING = 'GET_DOCTOR_PENDING';
export const GET_DOCTOR_SUCCESS = 'GET_DOCTOR_SUCCESS';
export const GET_DOCTOR_ERROR = 'GET_DOCTOR_ERROR';
